import {Article} from '../models/article';

export function presentationFormat(quantity: number, quantityPerUnit: number): string {
    if (quantityPerUnit <= 0) {
        return quantity + ' Un.';
    } else {
        let sign: string = '';
        if (quantity < 0) {
            sign = '-';
        }
        quantity = Math.abs(quantity);
        let quantityExistingText: string;
        let units: number = Math.trunc(quantity / quantityPerUnit);
        let fractional: number = quantity - (quantityPerUnit * units);
        let signFr: string = sign;
        if (fractional == 0) {
            signFr = '';
        }
        if (units == 0) {
            sign = '';
        }
        quantityExistingText = sign + units.toString() + ' Un. (' + signFr + fractional.toString() + 'Fr.)';
        return quantityExistingText;
    }
}

export class Pagination {
    public page: number;
    public cantpages: number;
    public cantpagesArray: number[];

    constructor() {
        this.page = 1;
    }
}

export function round(value) {
    return Math.round(value * 100.0) / 100.0;
}

export function toLong(value) {
    return (value * 100.0);
}

export function toShowMoney(value) {
    return (value / 100.0);
}

export function getArticlePrice(article: Article, list: number) {
    if (list === 1) {
        return article['unitPrice'];
    } else {
        let price = article['unitPrice' + list];
        while (price <= 0) {
            list--;
            if (list === 1) {
                price = article['unitPrice'];
            } else {
                price = article['unitPrice' + list];
            }
        }
        return price;
    }
}

